// this is an autogenerated file from DesignSystem/TasksMoveModal/Stage/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksMoveModal_Stage_Content($board_id: uuid!) {
  tasks_stages(
    where: { board_id: { _eq: $board_id } }
    order_by: { order: asc }
  ) {
    id
    text: name
  }
}

`